import { Router } from "@angular/router";
import { TranslateService } from "@ngstack/translate";

import { ICompany } from "src/app/interfaces/company";
import { IConfirm } from "src/app/interfaces/confirm";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CompanyEntryComponent } from "./company-entry/company-entry.component";
import { MatDialog, MatTableDataSource, MatPaginator } from "@angular/material";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { AddManagerEntryComponent } from "./add-manager-entry/add-manager-entry.component";
import { CompanyService } from "./../../../services/http/business/company/company.service";
import { CIDService } from "src/app/services/common/cid.service";

@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  styleUrls: ["./company.component.css"]
})
export class CompanyComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "CompanyName",
    "ProvinceName",
    "PhoneNumber",
    "FirsName",
    "StatusCode",
    "function"
  ];
  holdingCode: string;
  pageSize: number;
  pageIndex: number;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private companyService: CompanyService
  ) { }

  ngOnInit() {
    this.init();
  }

  init() {
    this.companyService.list().subscribe(
      res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  paginatorEvent(event) {
    this.companyService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  add(): void {
    this.dialog
      .open(CompanyEntryComponent, {
        maxWidth: "750px",
        minHeight: "500px"
      })
      .afterClosed()
      .subscribe(() => {
        this.companyService.list(0,0).subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  edit(element: ICompany): void {
    this.dialog
      .open(CompanyEntryComponent, {
        maxWidth: "750px",
        minHeight: "500px",
        data: element
      })
      .afterClosed()
      .subscribe(() => {
        this.companyService
          .list(this.pageIndex, this.pageSize)
          .subscribe(re => {
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
      });
  }

  delete(data: ICompany): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.company") + " " + data.CompanyName
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var xdata = {
          id: data.CompanyEncryptId
        };
        this.companyService.delete(xdata).subscribe(
          () => {
            this.companyService
              .list(this.pageIndex, this.pageSize)
              .subscribe(re => {
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  addManger(element: ICompany): void {
    this.dialog
      .open(AddManagerEntryComponent, {
        maxWidth: "500px",
        data: element.CompanyEncryptId
      })
      .afterClosed()
      .subscribe(() => {
        this.init();
      });
  }

  getToCalendar(params: any) {
    this.cidService.setCID(params.CompanyEncryptId);
    this.router.navigate(["../management/basic/company/calenderManagement/", decodeURI(params.CompanyEncryptId)]);
  }

  goToBranchPage(e: any) {
    this.cidService.setCID(e.CompanyEncryptId);
    this.router.navigate(["../management/basic/company/branch"]);
  }
}
